
module.exports = { 
      attributes: {},
    
      body: "Health services which consider the physical, cultural, social, and emotional wellbeing of Aboriginal and/or Torres Strait Islander people (Indigenous Australians).\n",
    
      meta: {"resourcePath":"/home/vsts/work/1/s/src/tenants/amh/content/categoryDescription/default/aboriginal-health-services.md"},
     }